module.exports = __webpack_public_path__ + "img/system_logo.24be8777.png";